module.exports = __webpack_public_path__ + "static/media/comment.26c05fe0.svg";